import { render, staticRenderFns } from "./ModuleOrderToPointForm.vue?vue&type=template&id=27dc0494&scoped=true&"
import script from "./ModuleOrderToPointForm.vue?vue&type=script&lang=js&"
export * from "./ModuleOrderToPointForm.vue?vue&type=script&lang=js&"
import style0 from "./ModuleOrderToPointForm.vue?vue&type=style&index=0&id=27dc0494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dc0494",
  null
  
)

export default component.exports